module.exports = __webpack_public_path__ + "static/media/sequoialogo.4f72710f.png";